module.exports = __webpack_public_path__ + "static/media/stage5.fa1bff9c.svg";